import { useState } from "react";
import { toast } from "sonner";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Button } from "@/components/ui/button";
import { Switch } from "@/components/ui/switch";
import { cn } from "@/lib/utils";
import { api, errMsg, fmtDate } from "@/lib/api";

export const INTEREST = [["high", "Very interested"], ["medium", "Some interest"], ["low", "Little interest"], ["none", "Not interested"]];

export function ViewingFeedback({ v, onSaved }) {
  const fb = v.feedback || {};
  const [f, setF] = useState({ interest: fb.interest || "", comments: fb.comments || "", share_with_landlord: !!fb.share_with_landlord });
  const [busy, setBusy] = useState(false);
  const save = async () => {
    if (!f.interest) return toast.error("Choose how interested the visitor was");
    setBusy(true);
    try {
      const r = await api.put(`/biz/viewings/${v.id}/feedback`, f);
      const mail = r.data.email_status === "sent" ? " — landlord emailed" : r.data.email_status === "skipped" ? " — landlord can see it in their portal (email not sent: SMTP not set up)" : "";
      toast.success(`Feedback saved${f.share_with_landlord ? mail || " and shared with the landlord" : ""}`);
      onSaved();
    } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  return (
    <div className="rounded-lg border border-slate-200 p-3 space-y-3" data-testid="viewing-feedback">
      <div className="flex justify-between items-baseline"><Label>Viewing feedback</Label>{fb.at && <span className="text-xs text-slate-400">Saved {fmtDate(fb.at)} by {fb.by}</span>}</div>
      <div className="grid grid-cols-2 gap-2">
        {INTEREST.map(([k, l]) => (
          <button key={k} type="button" onClick={() => setF({ ...f, interest: k })} data-testid={`feedback-interest-${k}`}
            className={cn("py-1.5 rounded-md border text-sm transition-colors", f.interest === k ? "bg-slate-900 border-slate-900 text-white" : "border-slate-200 hover:border-slate-900")}>{l}</button>
        ))}
      </div>
      <Textarea rows={3} value={f.comments} onChange={(e) => setF({ ...f, comments: e.target.value })} placeholder="What did they like or dislike? Any offer likely?" data-testid="feedback-comments" />
      <label className="flex items-center gap-2 text-sm"><Switch checked={f.share_with_landlord} onCheckedChange={(c) => setF({ ...f, share_with_landlord: c })} data-testid="feedback-share" />Share with the landlord</label>
      <Button size="sm" disabled={busy} onClick={save} className="bg-emerald-700 hover:bg-emerald-800 text-white" data-testid="feedback-save">Save feedback</Button>
    </div>
  );
}
